import type { FC } from 'react'

import * as Styled from './StepBar.styled'

interface StepBarProps {
  step: number
}

const MAX_STEPS = 5

export const StepBar: FC<StepBarProps> = ({ step }) => (
  <Styled.Container>
    {Array(MAX_STEPS)
      .fill(0)
      .map((_, i) => (
        <Styled.Step key={i} active={i <= step} />
      ))}
  </Styled.Container>
)
